import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { _TextTemp } from './templates/text/_textTemp';
import { _ImageTemp } from './templates/image/_imageTemp';
import { _CouponTemp } from './templates/coupon/_couponTemp';
/* Loads after template CSS imported by *_Temp so gallery overrides win. */
import './OnSiteLayoutGallery.css';

const LAYOUTS = [
  {
    type: 'TEXT',
    title: 'Modal',
    description: 'Title, body, image & button',
    Preview: _TextTemp,
  },
  {
    type: 'IMAGE',
    title: 'Image',
    description: 'Image-only spotlight',
    Preview: _ImageTemp,
  },
  {
    type: 'COUPON',
    title: 'Coupon',
    description: 'Offer with copyable code',
    Preview: _CouponTemp,
  },
];

function OnSiteLayoutGallery({ selectedType, onSelect }) {
  return (
    <div className="onsite-layout-gallery">
      {LAYOUTS.map(({ type, title, description, Preview }) => {
        const isSelected = selectedType === type;
        return (
          <div
            key={type}
            className={`onsite-layout-gallery__card${
              isSelected ? ' onsite-layout-gallery__card--selected' : ''
            }`}
            onClick={() => onSelect(type)}
          >
            <div className="onsite-layout-gallery__preview-wrap">
              <CloseOutlined className="onsite-layout-gallery__close" />
              <div className="onsite-gallery-preview">
                <Preview />
              </div>
            </div>
            <div className="onsite-layout-gallery__meta">
              <div className="onsite-layout-gallery__title">{title}</div>
              <div className="onsite-layout-gallery__description">
                {description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export { OnSiteLayoutGallery };
